/**
 * Enum trạng thái khi thêm vào danh mục chi thường xuyên
 */
export default {
    /// Trạng thái thêm
    Add: 1,

    /// Cập nhật
    Update: 2,

    /// Đã tồn tại
    Existed: 3,

    /// Không hợp lệ
    Error: 4,
};